export default __webpack_public_path__ + "static/media/sounds/maze_model_incorrect_answer_selected_twice.mp3";